module.exports = __webpack_public_path__ + "static/img/hardMRI1.6a843082.png";